import { oauthAuth } from "../standardAuthPatterns";
import { defineProduct, productVariant } from "../types";
import logo from "./logo.svg";

const publicEnvVars = (
  configuration: Record<string, string>
): Record<string, string> => {
  // Written by the managed OAuth flow's metadata, not a step input.
  const domain = configuration.domain;
  if (domain) {
    return { SALESFORCE_INSTANCE_URL: `https://${domain}.my.salesforce.com` };
  }
  return {};
};

export const salesforce = defineProduct({
  name: "Salesforce",
  tagLine: "CRM and business automation",
  logo,
  tags: ["featured", "it", "productivity"],
  variants: [
    productVariant({
      identifier: "salesforce",
      authLabel: "Production",
      protocol: "http",
      defaultUrlPattern: () => "https://.*\\.salesforce\\.com/.*",
      auth: oauthAuth,
      steps: [
        {
          title: "Connect your Salesforce account",
          items: [
            {
              kind: "oauth",
            },
          ],
        },
      ],
      oauth: {
        grantType: () => "authorization_code",
        authorizationEndpoint: () =>
          "https://login.salesforce.com/services/oauth2/authorize",
        tokenEndpoint: () =>
          "https://login.salesforce.com/services/oauth2/token",
        tokenEndpointAuthMethod: () => "client_secret_post",
        clientCredentialsFrom: "env",
      },
      connectionTest: {
        protocol: "http",
        request: () => "https://login.salesforce.com/services/oauth2/userinfo",
      },
      publicEnvVars,
    }),
    productVariant({
      identifier: "salesforceSandbox",
      authLabel: "Sandbox",
      protocol: "http",
      defaultUrlPattern: () => "https://.*\\.salesforce\\.com/.*",
      auth: oauthAuth,
      steps: [
        {
          title: "Connect your Salesforce sandbox account",
          items: [
            {
              kind: "oauth",
            },
          ],
        },
      ],
      oauth: {
        grantType: () => "authorization_code",
        authorizationEndpoint: () =>
          "https://test.salesforce.com/services/oauth2/authorize",
        tokenEndpoint: () =>
          "https://test.salesforce.com/services/oauth2/token",
        tokenEndpointAuthMethod: () => "client_secret_post",
        clientCredentialsFrom: "env",
      },
      connectionTest: {
        protocol: "http",
        request: () => "https://test.salesforce.com/services/oauth2/userinfo",
      },
      publicEnvVars,
    }),
  ],
});
